import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  OnDestroy,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { ImageUrls } from '../../types';
import { PeopleWidgetComponent } from '@alfresco/adf-process-services';
import { LightUserRepresentation } from '@alfresco/js-api';

@Component({
  selector: 'wk-people',
  templateUrl: './wk-people.widget.html',
  styleUrls: ['./wk-people.widget.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class WkPeopleWidgetComponent
  extends PeopleWidgetComponent
  implements AfterViewInit, OnDestroy, OnInit
{
  userImageBlobUrls = [] as ImageUrls[];
  private readonly destroy$ = new Subject<void>();

  ngOnInit(): void {
    // Subscribe to input changes
    this.searchTerm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.selectedUsers?.length) {
          this.selectedUsers = [];
          this.field.value = null;
          this.peopleSelected.emit(undefined);
        }
      });
  }
  @ViewChild('inputValue') inputRef!: ElementRef<HTMLInputElement>;

  isFocused = false;

  onFocus(): void {
    this.isFocused = true;
  }

  onBlur(): void {
    this.isFocused = false;
    this.markAsTouched();
  }

  ngAfterViewInit(): void {
    if (this.inputRef?.nativeElement && this.field?.placeholder) {
      this.inputRef.nativeElement.setAttribute(
        'placeholder',
        this.field.placeholder
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.userImageBlobUrls.forEach((url: ImageUrls) =>
      URL.revokeObjectURL(url.blobUrl)
    );
  }

  onItemSelect(user: LightUserRepresentation) {
    if (this.multiSelect) {
      if (!this.isUserAlreadySelected(user)) {
        this.selectedUsers.push(user);
      }
      this.field.value = this.selectedUsers;
    } else {
      this.selectedUsers = [user];
      this.field.value = user;
    }

    this.peopleSelected.emit(user?.id || undefined);
  }
}
